<template>
  <div>
    <b-modal id="modal-detailprodhistorique" centered ok-only ref="productdetails">
      <div>
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <!-- Text slides with image -->
          <b-carousel-slide v-for="(item, index) in product.photos" :key="index" :img-src="item"></b-carousel-slide>
        </b-carousel>

        <p class="mt-4">
          Nom du produit : {{ product.name }}
          <br />
          Client : {{ product.client.name }}
          <br />
          Numéro de téléphone : {{ product.client.phonenumber }}
          <br />
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "ProductDetails",
  props: {
    product: {
      type: Object,
      default: () => {
        return {client: {}};
      }
    }
  },
  data() {
    return {
      slide: 0
    };
  },
  methods: {
    showModal() {
      this.$refs.productdetails.show();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  }
};
</script>
                        